import { AiFillInstagram } from 'react-icons/ai';
import { PiButterflyFill } from "react-icons/pi";
import { SiLinktree, SiTiktok } from "react-icons/si";

import "./socialLinks.scss";

interface SocialLinksProps {
    width: number;
    height: number;
    size: number;
}

export default function SocialLinks({ width, height, size }: SocialLinksProps) {

    return (

        <div className="socialLinks__iconbox" style={{ width: width, height: height }}>
            <a href="https://www.instagram.com/storygoose" target="_blank" rel="noopener noreferrer" className="socialLinks__Link" style={{ width: size, height: size }}>
                <AiFillInstagram className="socialLinks__icon" />
            </a>
            <a href="http://tiktok.com/@thestorygoose" target="_blank" rel="noopener noreferrer" className="socialLinks__Link" style={{ width: size, height: size }}>
                <SiTiktok className="socialLinks__icon" />
            </a>
            <a href="https://bsky.app/profile/dragons.bsky.social" target="_blank" rel="noopener noreferrer" className="socialLinks__Link" style={{ width: size, height: size }}>
                <PiButterflyFill className="socialLinks__icon" />
            </a>
            <a href="https://linktr.ee/ThePoetEmpress" target="_blank" rel="noopener noreferrer" className="socialLinks__Link" style={{ width: size, height: size }}>
                <SiLinktree className="socialLinks__icon" />
            </a>
        </div>
    )
}